import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, ArrowLeft } from 'lucide-react';

const PanipuravthaNamuna2Report = () => {
    const navigate = useNavigate();
    const [date, setDate] = useState('2026-03-31');

    return (
        <div className="h-screen overflow-hidden bg-gray-50 flex items-center justify-center p-4 font-poppins">
            <div className="w-full max-w-lg bg-white rounded-lg shadow-xl overflow-hidden border border-gray-200 relative">
                
                {/* Header */}
                <div className="bg-[#267c77] text-white p-4 flex items-center gap-4">
                    <button 
                        onClick={() => navigate(-1)}
                        className="p-1 hover:bg-white/20 rounded-full transition-colors"
                    >
                        <ArrowLeft size={24} />
                    </button>
                    <h2 className="text-xl font-bold">नमुना २ (पुनर्विनियोजन अंदाजपत्रक)</h2>
                </div>

                {/* Body */}
                <div className="p-8 flex items-center justify-center gap-4">
                    <label className="text-gray-700 font-medium text-lg">दिनांक</label>
                    <div className="relative">
                        <input 
                            type="date" 
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            className="p-2 pr-10 border border-gray-300 rounded bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                        />
                        <Calendar className="absolute right-3 top-2.5 text-gray-500 w-5 h-5 pointer-events-none" />
                    </div>
                </div>

                {/* Footer / Button Area */}
                <div className="bg-[#267c77] p-4 flex justify-center">
                    <button 
                        className="bg-[#10b981] hover:bg-[#059669] text-white px-8 py-2 rounded font-bold text-lg shadow-md transition-colors"
                        onClick={() => {
                            // Define print route later
                            console.log("Generate Namuna 2 Report", date);
                             // navigate('/panipuravtha/financial-report/namuna-2/print', { state: { date } });
                        }}
                    >
                        नमुना २
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PanipuravthaNamuna2Report;
